import AccountStore from './stores/Account'
import React from 'react'

import { createTheme, ThemeOptions } from '@mui/material/styles'
import { Shadows } from '@mui/material/styles/shadows'

declare module '@mui/material/styles' {
  interface TypographyVariants {
    small: React.CSSProperties
    mini: React.CSSProperties
    label: React.CSSProperties
  }
  interface TypographyVariantsOptions {
    small?: React.CSSProperties
    mini?: React.CSSProperties
    label?: React.CSSProperties
  }
  interface Palette {
    brand: Palette['primary']
    brandYellow: Palette['primary']
  }
  interface PaletteOptions {
    brand: PaletteOptions['primary']
    brandYellow: PaletteOptions['primary']
  }

  interface PaletteColor {
    brand?: string
    brandYellow?: string
  }
  interface SimplePaletteColorOptions {
    brand?: string
    brandYellow?: string
  }
}
declare module '@mui/material/Typography' {
  interface TypographyPropsColorOverrides {
    brand: true
    brandYellow: string
  }
  interface TypographyPropsVariantOverrides {
    small: true
    mini: true
    label: true
  }
}

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    health: true
    flag: true
  }
  interface ChipPropsColorOverrides {
    brand: true
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    brand: true
    brandYellow: string
  }
}
declare module '@mui/material/ButtonGroup' {
  interface ButtonPropsColorOverrides {
    brand: true
  }
}
declare module '@mui/material/Switch' {
  interface SwitchPropsColorOverrides {
    brand: true
  }
}

declare module '@mui/material/ToggleButton' {
  interface ToggleButtonPropsColorOverrides {
    brand: true
    brandYellow: true
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    brand: true
  }
}
declare module '@mui/material/AppBar' {
  interface AppBarPropsColorOverrides {
    brand: true
  }
}

type Contrast = 'light' | 'dark'

const primary = '#140a9a'
const primaryColor = {
  50: '#F9FAFB',
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D1D5DB',
  400: '#9CA3AF',
  500: '#6B7280',
  600: '#4B5563',
  700: '#374151',
  800: '#1F2937',
  900: '#111827'
}
// const primaryColor = {
//   50: primary,
//   100: primary,
//   200: primary,
//   300: primary,
//   400: primary,
//   500: primary,
//   600: primary,
//   700: primary,
//   800: primary,
//   900: primary,
//   A100: primary,
//   A200: 'white',
//   A400: 'white',
//   A700: 'white',
//   contrastDefaultColor: 'light' as Contrast
// }

const primaryColorCastrol = {
  50: '#00833b',
  100: '#00833b',
  200: '#00833b',
  300: '#00833b',
  400: '#00833b',
  500: '#00833b',
  600: '#00833b',
  700: '#00833b',
  800: '#00833b',
  900: '#00833b',
  A100: 'rgb(192, 193, 247)',
  A200: 'white',
  A400: 'white',
  A700: 'white',
  contrastDefaultColor: 'light' as Contrast
}

const secondaryColorCastrol = {
  50: '#f5564a',
  100: '#f5564a',
  200: '#f5564a',
  300: '#f5564a',
  400: '#f5564a',
  500: '#f5564a',
  600: '#f5564a',
  700: '#f5564a',
  800: '#f5564a',
  900: '#f5564a',
  A100: '#f5564a',
  A200: '#f5564a',
  A400: '#f5564a',
  A700: '#f5564a',
  contrastDefaultColor: 'dark' as Contrast
}

// const secondaryColor = '#424551'
const secondaryColor = {
  50: '#424551',
  100: '#424551',
  200: '#424551',
  300: '#424551',
  400: '#424551',
  500: '#424551',
  600: '#424551',
  700: '#424551',
  800: '#424551',
  900: '#424551',
  A100: '#424551',
  A200: '#424551',
  A400: '#424551',
  A700: '#424551',
  contrastDefaultColor: 'dark' as Contrast
}

// const secondaryColor = {
//   50: '#ffd700',
//   100: '#ffd700',
//   200: '#ffd700',
//   300: '#ffd700',
//   400: '#ffd700',
//   500: '#ffd700',
//   600: '#ffd700',
//   700: '#ffd700',
//   800: '#ffd700',
//   900: '#ffd700',
//   A100: '#ffd700',
//   A200: '#ffd700',
//   A400: '#ffd700',
//   A700: '#ffd700',
//   contrastDefaultColor: 'dark' as Contrast
// }

const primaryColorCaltex = {
  50: '#014B60',
  100: '#014B60',
  200: '#014B60',
  300: '#014B60',
  400: '#014B60',
  500: '#014B60',
  600: '#014B60',
  700: '#014B60',
  800: '#014B60',
  900: '#014B60',
  A100: 'white',
  A200: 'white',
  A400: 'white',
  A700: 'white',
  contrastDefaultColor: 'light' as Contrast
}

const secondaryColorCaltex = {
  50: '#f5564a',
  100: '#f5564a',
  200: '#f5564a',
  300: '#f5564a',
  400: '#f5564a',
  500: '#f5564a',
  600: '#f5564a',
  700: '#f5564a',
  800: '#f5564a',
  900: '#f5564a',
  A100: '#f5564a',
  A200: '#f5564a',
  A400: '#f5564a',
  A700: '#f5564a',
  contrastDefaultColor: 'dark' as Contrast
}
const grey = {
  50: '#F9FAFB',
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D1D5DB',
  400: '#9CA3AF',
  500: '#6B7280',
  600: '#4B5563',
  700: '#374151',
  800: '#1F2937',
  900: '#111827'
}

const getBrandColor = () => {
  if (AccountStore.isWhitelabel) {
    if (AccountStore.isLabCheck) return primaryColorCastrol[500]
    if (AccountStore.isLubeWatch) return primaryColorCaltex[500]
  }
  return primary
}

const borderRadius = [8, 10, 16]

// const customShadow = '0px 2px 10px 0px rgba(0, 0, 0, 0.10)'
const customShadow =
  '0px 0px 2px 0px rgba(0, 0, 0, 0.15), 0px 2px 5px 0px rgba(0, 0, 0, 0.05), 0px 8px 40px 0px rgba(0, 0, 0, 0.04)'

// todo replace these from the theme
const customColours = {
  dividerColour: '#EDEFF1',
  dialogBorder: '#DCE0E6',
  black087: 'rgba(0, 0, 0, 0.87)',
  buttonText: '#424551'
}

const theme = createTheme({
  // basics
  shadows: Array.from({ length: 25 }, (_, index) =>
    index === 1 ? customShadow : 'none'
  ) as Shadows,
  spacing: 8,
  shape: {
    borderRadius: 8
  },
  components: {
    MuiTableSortLabel: {
      styleOverrides: {
        iconDirectionAsc: {
          transform: 'rotate(0deg)'
        },
        iconDirectionDesc: {
          transform: 'rotate(180deg)'
        }
      }
    },

    // Input components are now defined in actualTheme section
    MuiMenu: {
      styleOverrides: {
        list: { paddingTop: 0, paddingBottom: 0 },
        root: {
          borderRadius: 10,
          filter:
            'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.06)) drop-shadow(0px 8px 14px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 1px rgba(200, 200, 200, 0.82))'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '13px',
          lineHeight: '24px',
          color: '#110F24',
          fontWeight: 500,
          borderRadius: 9,
          margin: '4px 4px 4px 4px',
          padding: '4px 10px'
        }
      }
    }
  },
  typography: {
    fontFamily: ['Noto Sans', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    fontSize: 13,
    fontWeightRegular: 400,
    fontWeightBold: 600,
    h1: {
      fontSize: 34,
      fontWeight: 700,
      lineHeight: '120%',
      color: '#31363E'
    },
    h2: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '24px'
    },
    h3: {
      fontSize: 17,
      fontWeight: 600,
      lineHeight: '24px'
    },
    h4: {
      fontSize: 15,
      fontWeight: 600,
      lineHeight: '24px'
    },
    body1: {
      fontWeight: 600,
      fontSize: '13px',
      lineHeight: '24px',
      color: '#31363E'
    },
    body2: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.2px',
      color: grey[500]
    },
    small: {
      fontWeight: 500,
      fontSize: '11px',
      lineHeight: '16px',

      letterSpacing: '0.6px',
      textTransform: 'uppercase',

      color: grey[600]
    },
    label: {
      fontSize: 11,
      letterSpacing: 0.6,
      textTransform: 'uppercase',
      fontWeight: 400,
      lineHeight: '16px',
      color: grey[500]
    },
    // disable variants not in the design system
    h5: undefined,
    h6: undefined,
    subtitle1: undefined,
    subtitle2: undefined,
    caption: undefined,
    overline: undefined
  },
  palette: {
    // KOMATSU blue
    brand: {
      main: getBrandColor(),
      contrastText: '#fff'
    },
    brandYellow: {
      main: '#FFC82F',
      contrastText: '#424551'
    },
    mode: 'light',
    primary: {
      main: AccountStore.isWhitelabel ? getBrandColor() : grey[900],
      contrastText: '#fff'
    },
    secondary: {
      main: customColours.buttonText,
      contrastText: grey[900]
    },
    // Black
    // primary: {
    //   main: grey[900],
    //   contrastText: '#fff'
    // },
    // // Light Grey
    // secondary: {
    //   main: customColours.buttonText,
    //   contrastText: '#424551' // grey[900] // TODO
    // },
    // Red
    error: {
      // main: 'rgba(255, 0, 0, 0.1)',
      main: '#F44336',
      light: 'rgba(255, 0, 0, 0.7)',
      contrastText: '#fff'
      // contrastText: '#f00'
    },
    // success: {
    //   main: '#2BB673',
    //   contrastText: '#fff'
    // },
    info: {
      // brand colour
      main: '#140a9a',
      contrastText: '#fff'
    },
    // Override MUI grey
    grey: grey
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 650,
      md: 960,
      lg: 1280,
      xl: 1680
    }
  }
})

const actualTheme: ThemeOptions = {
  // overrides - shared with myFleet
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          lineHeight: '16px',
          // background: `radial-gradient(265.3% 70.71% at 50% 50%, rgba(194, 206, 249, 0.15) 0%, rgba(241, 243, 254, 0.15) 79.69%), #FFF;`
          background: '#F9F9FF'
        }
      }
    },
    MuiContainer: {
      defaultProps: {
        maxWidth: 'xl'
      },
      styleOverrides: {
        root: {
          // Use theme.breakpoints for responsive padding
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
          [theme.breakpoints.up('xs')]: {
            padding: theme.spacing(2, 1, 0, 1)
          },
          [theme.breakpoints.up('md')]: {
            padding: theme.spacing(2, 4, 0, 4)
          }
          // [theme.breakpoints.up('md')]: {
          //   paddingLeft: '32px',
          //   paddingRight: '32px'
          // },
          // [theme.breakpoints.up('lg')]: {
          //   paddingLeft: '40px',
          //   paddingRight: '40px'
          // },
          // [theme.breakpoints.up('xl')]: {
          //   paddingLeft: '48px',
          //   paddingRight: '48px'
          // }
        },
        disableGutters: {
          padding: 0
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: '52px !important'
        }
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          background: theme.palette.common.white,
          boxShadow: theme.shadows[1]
        }
      }
    },
    MuiTable: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          lineHeight: '24px',
          borderBottom: '1px solid #ECEEF1',
          padding: '14px 10px'
        },
        sizeSmall: {
          lineHeight: '20px',
          borderBottom: '1px solid #ECEEF1'
        },
        sizeMedium: {
          padding: '10px 14px'
        },
        head: {
          color: theme.palette.secondary.contrastText,
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: '24px'
        },
        paddingCheckbox: { padding: '0 10px' }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:has(> td):hover': {
            // https://caniuse.com/css-has
            background: '#F6F8FA'
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #EAECF0'
        }
      }
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
        disableFocusRipple: true,
        disableTouchRipple: true
      },
      styleOverrides: {
        root: {
          fontSize: 15,
          opacity: 0.5,
          fontWeight: 600,
          lineHeight: 20,
          letterSpacing: '-0.08px',
          minWidth: '0px',
          padding: theme.spacing(1, 0),
          height: '36px',
          color: '#000',
          border: '2px solid transparent',
          margin: '0 16px 0 0',
          // use Sentence case
          textTransform: 'none',
          '&:hover': {
            color: 'black',
            borderBottom: '2px solid black',
            opacity: 1
          },
          '&.Mui-selected': {
            color: '#000',
            opacity: 1
          }
        }
      }
    },

    MuiToggleButtonGroup: {
      defaultProps: {
        exclusive: true
      },
      styleOverrides: {
        root: {
          // background: grey[200],
          background: 'rgba(36, 41, 65, 0.06)',
          padding: 4,
          height: 36
        }
      }
    },
    MuiToggleButton: {
      defaultProps: {
        disableRipple: true,
        disableFocusRipple: true
      },
      styleOverrides: {
        root: {
          fontWeight: 500,
          gap: 6,
          border: 'none',
          textTransform: 'none',
          color: '#6F717C',
          '&.Mui-selected': {
            padding: '4px 8px 4px 8px',
            height: '28px',
            borderRadius: 6,
            color: '#0F1324',
            backgroundColor: 'white',
            boxShadow:
              '0px 4px 4px rgba(0, 0, 0, 0.06), 0px 8px 14px rgba(0, 0, 0, 0.1), 0px 0px 1px rgba(200, 200, 200, 0.82)',
            '&:not(:last-of-type)': {
              borderRadius: 6
            },
            '&:not(:first-of-type)': {
              borderTopLeftRadius: 6,
              borderBottomLeftRadius: 6
            }
          }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        fullWidth: true
      }
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        color: 'secondary',
        size: 'medium',
        disableRipple: true,
        disableFocusRipple: true
      },
      variants: [
        {
          props: { color: 'brand' },
          style: {
            '&:hover': {
              background: `linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), ${getBrandColor()}`
            },
            '&:active': {
              background: `linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), ${getBrandColor()}`
            }
          }
        },
        {
          props: { variant: 'text' },
          style: {
            border: 'none',
            boxShadow: 'none'
          }
        },
        {
          props: { variant: 'text', color: 'brand' },
          style: {
            '&:hover, &:active': {
              background: '#F6F8FA'
            }
          }
        },
        {
          props: { color: 'primary', variant: 'contained' },
          style: {
            '&:hover, &:active': {
              background: '#F6F8FA',
              color: 'black'
            }
          }
        },
        {
          props: { color: 'secondary', variant: 'contained' },
          style: {
            background: 'white',
            '&:hover, &:active': {
              background: '#F6F8FA'
            }
          }
        }
      ],
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          fontWeight: 400,
          // boxShadow: 'none',
          textTransform: 'none',
          fontSize: 14,
          padding: '4px 8px',
          height: 32,
          lineHeight: '16px',
          // background: '#FFF',
          border: '1px #ECEEF1 solid',
          boxShadow: '0px 1px 2px 0px rgba(20, 21, 26, 0.05)'
          // boxShadow: theme.shadows[1]
        },
        startIcon: {
          marginRight: '6px'
        },
        endIcon: {
          marginLeft: '4px'
        },
        sizeSmall: { fontSize: 12, padding: '4px 10px', height: 28 },
        sizeMedium: {
          fontSize: 14,
          padding: '6px 14px',
          height: 32
        },
        sizeLarge: {
          fontSize: 14,
          padding: '8px 8px 8px 12px',
          height: 36
        },
        iconSizeSmall: {
          '& > *:first-child': {
            fontSize: 18
          }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */
        iconSizeMedium: {
          '& > *:first-child': {
            fontSize: 20
          }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */
        iconSizeLarge: {
          '& > *:first-child': {
            fontSize: 16
          }
        }
      }
    },

    MuiSvgIcon: {
      styleOverrides: {
        fontSizeSmall: {
          fontSize: 16,
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '100%'
        }
      }
    },
    MuiIconButton: {
      defaultProps: {
        disableFocusRipple: true,
        disableRipple: true,
        disableTouchRipple: true
      },
      styleOverrides: {
        root: {
          '&:hover': {
            background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #F3F4F6'
          }
        }
      }
    },
    MuiAccordion: {
      defaultProps: {
        disableGutters: true
      },
      styleOverrides: {
        root: {
          border: '1px solid #EAECF0',
          width: '100%',
          '&:first-child': {
            borderRadius: '12px 12px 0 0',
            borderTop: 0
          },
          borderTop: '1px solid #E5E7EB',
          '&:before': {
            display: 'none'
          },
          '&.Mui-expanded': { margin: 0, '&::before': { opacity: 1 } }
        }
      }
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          boxShadow:
            '0px 4px 4px rgba(0, 0, 0, 0.06), 0px 8px 14px rgba(0, 0, 0, 0.1), 0px 0px 1px rgba(200, 200, 200, 0.82)',
          borderRadius: '16px',
          color: '#110F24',
          margin: 0.5,
          padding: 1,

          '.MuiMenuItem-root': {
            fontWeight: 600,
            fontSize: '15px',
            padding: '18px 24ox'
          }
        }
      }
    },
    MuiListItem: {
      styleOverrides: {}
    },
    MuiListItemText: {
      styleOverrides: {
        // root: { padding: '10px 24px' },
        primary: {
          letterSpacing: '0.6px',
          textTransform: 'none',
          color: grey[600],
          fontWeight: 700,
          fontSize: '12px',
          lineHeight: '16px'
        },
        secondary: {
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '24px',
          color: grey[900]
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        list: { paddingTop: 0, paddingBottom: 0 },
        root: {
          borderRadius: 10,
          filter:
            'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.06)) drop-shadow(0px 8px 14px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 1px rgba(200, 200, 200, 0.82))'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '13px',
          lineHeight: '24px',
          color: '#110F24',
          fontWeight: 500,
          borderRadius: 9,
          margin: '4px 4px 4px 4px',
          padding: '4px 10px'
        }
      }
    },
    MuiCircularProgress: {
      defaultProps: {
        color: 'info'
      }
    },
    MuiInput: {
      defaultProps: {
        disableUnderline: true
      },
      styleOverrides: {
        root: {
          background: '#FFFFFF',
          borderRadius: '8px',
          padding: '5px 0 7px 10px',
          fontWeight: 400,
          margin: '6px 0',
          fontSize: '13px',
          lineHeight: '24px',
          minHeight: '36px',
          border: '1px solid #E5E7EB',
          boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            background: '#F3F4F6'
          },
          '&.Mui-focused': {
            background: '#FFFFFF',
            border: '1px solid #111827',
            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px, 0 0 0 2px rgba(17, 24, 39, 0.1)',
            outline: 'none'
          },
          '&.Mui-error': {
            background: '#FFFFFF',
            border: '1px solid #d32f2f',
            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
            '&.Mui-focused': {
              boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px, 0 0 0 2px rgba(211, 47, 47, 0.1)'
            }
          },
          '&:disabled': {
            background: '#F9FAFB',
            opacity: 0.6,
            cursor: 'not-allowed'
          }
        },
        inputTypeSearch: {
          color: grey[500],
          fontWeight: 400,
          fontSize: '14px',
          padding: '5px 12px 5px 0px',
          lineHeight: '24px',
          height: '49px !important',
          '::placeholder': {
            letterSpacing: '-0.01px',
            opacity: 1
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          lineHeight: '24px',
          margin: 0,
          padding: 0,
          height: 'auto'
        },
        root: {
          '&.MuiAutocomplete-inputRoot': {
            margin: 0,
            padding: '6px 14px',
            minHeight: 'auto',
            '&.Mui-focused': {
              boxShadow: 'none !important',
              border: 'none !important'
            }
          }
        }
      }
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          overflow: 'visible'
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        standard: {
          display: 'flex',
          borderRadius: '10px',
          border: '1px solid #ECEEF1',
          padding: '9px 16px !important',
          maxHeight: '36px',
          background: 'white'
        }
      }
    },
    MuiTooltip: {
      defaultProps: {
        // https://stackoverflow.com/questions/69030402/material-ui-tooltip-is-not-working-on-mobile
        enterTouchDelay: 0
      },
      styleOverrides: {
        tooltip: {
          // background: 'white',
          padding: '13px 15px',
          // color: customColours.black087,
          boxShadow: theme.shadows[1]
        },
        arrow: {
          fontSize: 20,
          '&::before': {
            // backgroundColor: 'white',
            boxShadow: theme.shadows[1]
          }
        }
      }
    },
    MuiCard: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          borderRadius: '12px',
          border: '1px solid rgba(0, 0, 0, 0.08)',
          flex: 1
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 0,
          '&:last-child': {
            paddingBottom: 0
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          padding: '4px 8px',
          cursor: 'inherit'
        },
        label: {
          padding: 0,
          fontSize: '12px'
        },
        icon: {
          width: '16px',
          height: '16px',
          marginRight: '4px',
          marginLeft: '0px'
        },
        deleteIcon: { margin: '0 0 0 4px' }
      },
      variants: [
        {
          props: { variant: 'flag' },
          style: {
            borderRadius: '4px',
            letterSpacing: '0.3px',
            fontSize: '10px',
            lineHeight: '16px',
            fontWeight: '500',
            height: '16px',
            padding: '0 4px',
            gap: '6px',
            display: 'flex'
          }
        },
        {
          props: { variant: 'health' },
          style: {
            padding: '3px 7px',
            textTransform: 'uppercase',
            color: '#6B7280',
            backgroundColor: '#F3F4F6',
            borderRadius: '6px',
            letterSpacing: '0.6px',
            fontSize: '11px',
            lineHeight: '16px',
            height: '22px'
          }
        },
        {
          props: { variant: 'health', color: 'error' },
          style: {
            color: 'white',
            backgroundColor: 'red'
          }
        },
        {
          props: { color: 'brand' },
          style: {
            backgroundColor: getBrandColor(),
            color: '#fff',
            '&:hover': {
              background: `linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), ${getBrandColor()}`
            }
          }
        }
      ]
    },
    MuiDialog: {
      styleOverrides: {
        paperFullWidth: {
          margin: 0,
          width: 'calc(100% - 48px)'
        },
        root: {
          filter:
            'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.06)) drop-shadow(0px 8px 14px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 1px rgba(200, 200, 200, 0.82))'
        }
      }
    },

    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '8px 24px'
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          minHeight: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          paddingTop: '20px !important',
          borderTop: '1px solid ' + customColours.dialogBorder,
          borderBottom: '1px solid ' + customColours.dialogBorder
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          letterSpacing: '0.2px',
          '&.Mui-error': {
            color: '#d32f2f'
          }
        }
      }
    },
    MuiAutocomplete: {
      defaultProps: {
        multiple: true,
        size: 'small'
      },
      styleOverrides: {
        paper: {
          marginTop: '8px',
          filter:
            'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.06)) drop-shadow(0px 8px 14px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 1px rgba(200, 200, 200, 0.82))'
        },
        listbox: {
          padding: '4px',
          // only applies to grouped autocompletes like in mobile reports
          '&>li:not(.MuiAutocomplete-option):not(:last-child)': {
            borderBottom: '1px solid ' + customColours.dividerColour
          }
        },
        root: {
          borderRadius: theme.shape.borderRadius,
          border: '1px solid #E5E7EB',
          background: '#FFFFFF',
          boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
          transition: 'all 0.2s ease-in-out',
          '.MuiInputLabel-root': {
            color: grey[500],
            fontWeight: 600,
            fontSize: '13px',
            lineHeight: '24px'
          },
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '.MuiInput-root': {
            '&::before, &::after': {
              display: 'none !important'
            }
          },
          '&:hover': {
            background: '#F3F4F6'
          },
          '&.Mui-focused': {
            background: '#FFFFFF',
            border: '1px solid #111827',
            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px, 0 0 0 2px rgba(17, 24, 39, 0.1)',
            outline: 'none'
          }
        },
        groupLabel: {
          fontSize: 11,
          letterSpacing: 0.6,
          textTransform: 'uppercase',
          fontWeight: 400,
          lineHeight: '16px',
          color: grey[500],
          padding: '6px 8px'
        },
        inputRoot: {
          padding: '6px 14px !important',
          flexWrap: 'nowrap',
          background: 'transparent !important',
          margin: '0 !important',
          minHeight: 'auto !important',
          borderRadius: theme.shape.borderRadius,
          border: 'none !important',
          '&::before, &::after': {
            display: 'none !important'
          },
          '&.Mui-focused': {
            boxShadow: 'none !important',
            border: 'none !important'
          },
          '& .MuiInputBase-input': {
            padding: '0 !important',
            height: 'auto',
            minHeight: 'auto'
          }
        },

        input: {
          '&::placeholder': { opacity: 1 },
          padding: '0 !important',
          minWidth: '1px !important'
        },
        endAdornment: {
          marginRight: 8
        },
        option: {
          borderRadius: '10px',
          fontWeight: '500',
          fontSize: '13px',
          lineHeight: '24px',
          color: '#110F24',
          padding: '6px 8px !important',
          '.MuiCheckbox-root': {
            padding: '0px 8px 0 0 '
          }
        },
        hasClearIcon: {
          background: '#FFFFFF',
          border: '1px solid #111827',
          boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px, 0 0 0 2px rgba(17, 24, 39, 0.1)'
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          '&:hover': {
            textDecoration: 'none',
            cursor: 'pointer'
          }
        }
      }
    },
    MuiDivider: {
      defaultProps: {
        flexItem: true
      },
      styleOverrides: {
        root: {
          borderColor: customColours.dividerColour,
          width: '100%'
        },
        vertical: {
          width: 'auto'
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#db3131',
          '&$error': {
            color: '#db3131'
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '&.MuiPickersPopper-paper': {
            marginTop: '8px',
            borderRadius: '12px',
            boxShadow: theme.shadows[1],
            border: '1px solid #ECEEF1'
          }
        }
      }
    },
    MuiAlert: {}
  }
}

const fullTheme = createTheme(theme, actualTheme)

export default fullTheme
